import React from "react";
import { Checkbox } from "antd";

const SbCheckbox = ({ checked, onChange, onClick, disabled, title, ...rest }) => {
  return (
    <Checkbox
      checked={checked}
      onChange={onChange}
      onClick={onClick}
      disabled={disabled}
      title={title}
      {...rest}
    />
  );
};

export default SbCheckbox;